import { useNavigate } from "react-router-dom";
import { PartyPopper } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { IMG_MATCH_BG } from "../lib/images";
import { formatSessionDateTime } from "../lib/dateUtils";

const CONFETTI_COLORS = ["#FF6B35", "#FFFFFF", "#1A1A1A", "#FF9466"];

export const MatchRevealModal = ({ booking, onDismiss }) => {
  const navigate = useNavigate();
  const session = booking?.session;

  const dismiss = async (navigateToBooking) => {
    try {
      await api.put(`/bookings/${booking.id}/mark-match-seen`);
    } finally {
      onDismiss();
      if (navigateToBooking) navigate(`/dashboard/bookings/${booking.id}`);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-5" data-testid="match-reveal-modal">
      <div className="absolute inset-0">
        <img src={IMG_MATCH_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-midnight-black/85" />
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {Array.from({ length: 28 }).map((_, i) => (
          <span
            key={i}
            className="confetti-piece"
            style={{
              left: `${(i * 3.7) % 100}%`,
              backgroundColor: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
              animationDelay: `${(i % 10) * 0.15}s`,
              animationDuration: `${2.5 + (i % 5) * 0.4}s`,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-lg text-center animate-reveal-in">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-stranger-orange mb-6 animate-reveal-pop">
          <PartyPopper className="w-8 h-8 text-clean-white" />
        </div>
        <p className="text-stranger-orange font-bold tracking-[0.3em] uppercase text-xs mb-4 animate-reveal-in-delay-1">You've Been Matched</p>
        <h1 className="text-clean-white font-extrabold uppercase text-4xl sm:text-5xl mb-6 tracking-tight animate-reveal-in-delay-2" data-testid="match-reveal-headline">
          Your Stranger is waiting.
        </h1>
        <p className="text-clean-white/80 font-medium mb-8 animate-reveal-in-delay-3">
          {session?.title} · {formatSessionDateTime(session?.session_date, session?.session_time)}
        </p>
        <p className="text-clean-white/60 italic font-medium text-sm mb-10 animate-reveal-in-delay-3">Don't worry. They don't know who you are either.</p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center animate-reveal-in-delay-3">
          <Button data-testid="view-match-details-button" onClick={() => dismiss(true)} className="bg-stranger-orange hover:bg-orange-600 text-clean-white font-bold rounded-full px-8 py-6">
            SEE MY MATCH DETAILS
          </Button>
          <Button
            data-testid="dismiss-match-reveal-button"
            variant="outline"
            onClick={() => dismiss(false)}
            className="rounded-full font-bold border-white/30 text-clean-white bg-transparent hover:bg-white/10 px-8 py-6"
          >
            MAYBE LATER
          </Button>
        </div>
      </div>
    </div>
  );
};
